/**
 * Just modified version of useEffect that's executed only one time, at the mounting time.
 * @param {React.EffectCallback} effect
 */
export const useEffectOnce = (effect: React.EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(effect, [])
}
